import { render, staticRenderFns } from "./account.change-password.vue?vue&type=template&id=f4633d84&"
import script from "./account.change-password.vue?vue&type=script&lang=js&"
export * from "./account.change-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports